import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
import navbar from "./navbar";
import global from "./global";

export default new Vuex.Store({
    modules: {
        navbar,
        global,
    }
})

